import fetch from '../../../utils/fetch';
import {
    USER_UPDATE_EXPORT_SUCCESS,
    USER_UPDATE_RESET,
    USER_UPDATE_RETRIEVE_SUCCESS,
    USER_UPDATE_UPDATE_SUCCESS
} from './mutation-types';
import {CURRENT_USER, EXPORT_USER_DATA, USER} from '../../../constants/api-routes';


const getDefaultState = () => {
    return {
        retrieved: null,
        updated: null,
        exportRetrieved: null
    };
};
const state = getDefaultState();

function retrieveSuccess(retrieved) {
    return {type: USER_UPDATE_RETRIEVE_SUCCESS, retrieved};
}

function exportSuccess(retrieved) {
    return {type: USER_UPDATE_EXPORT_SUCCESS, retrieved};
}

function updateSuccess(updated) {
    return {type: USER_UPDATE_UPDATE_SUCCESS, updated};
}

function reset() {
    return {type: USER_UPDATE_RESET};
}

const getters = {
    retrieved: state => state.retrieved,
    updated: state => state.updated,
    updateLoading: state => state.updateLoading,
    exportUrl: state => state.exportRetrieved !== null ? 'data:application/json,' + encodeURIComponent(state.exportRetrieved) : null
};

const actions = {
    retrieve({commit}) {
        return fetch(CURRENT_USER)
            .then(data => {
                commit(retrieveSuccess(data));
            });
    },
    update({commit, state}, {item, values}) {
        return fetch(USER + item['@id'], {
            method: 'PUT',
            headers: new Headers({'Content-Type': 'application/ld+json'}),
            data: values,
        }, false).then(data => {
            commit(updateSuccess(data));
        });
    },
    retrieveExport({commit}) {
        return fetch(EXPORT_USER_DATA).then((exportRetrieved) => {
            commit(exportSuccess(exportRetrieved));
        });
    },
    reset({commit}) {
        commit(reset());
    },
};

const mutations = {
    [USER_UPDATE_RETRIEVE_SUCCESS](state, payload) {
        state.retrieved = payload.retrieved;
    },
    [USER_UPDATE_EXPORT_SUCCESS](state, {retrieved}) {
        state.exportRetrieved = retrieved;
    },
    [USER_UPDATE_UPDATE_SUCCESS](state, payload) {
        state.updated = payload.updated;
    },
    [USER_UPDATE_RESET](state) {
        Object.assign(state, getDefaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user/update.js